import { AxiosError } from 'axios'
import { setNetworkError } from '..'
import { axiosInstance } from '../../helpers'
import { CreateServiceRequest, Service } from '../../models'
import { AppThunk, ErrorResponse } from '../types'
import {
    CreateServiceActionThunk,
    CREATE_SERVICE_RESPONSE,
    GetServiceListActionThunk,
    GetServiceListRequest,
    GET_SERVICE_LIST_REQUEST,
    GET_SERVICE_LIST_RESPONSE,
    ServiceActionTypes,
    SET_SERVICE_LIST,
} from './types'

export const getServiceList = (
    req: GetServiceListRequest,
): AppThunk<GetServiceListActionThunk> => {
    return async (dispatch) => {
        // begin request
        dispatch({
            type: GET_SERVICE_LIST_REQUEST,
        })

        const url = 'service/'

        try {
            // success
            const response = await axiosInstance.get(url, req)

            dispatch({
                type: GET_SERVICE_LIST_RESPONSE,
                payload: response.data,
            })

            return response
        } catch (e) {
            // error handling
            const error = e as AxiosError<ErrorResponse>
            dispatch(setNetworkError(error, true))

            return new Promise((_, reject) => {
                reject(error)
            })
        }
    }
}

export const createService = (
    req: CreateServiceRequest,
): AppThunk<CreateServiceActionThunk> => {
    return async (dispatch) => {
        const url = 'service/'

        try {
            const response = await axiosInstance.post(url, req)

            dispatch({
                type: CREATE_SERVICE_RESPONSE,
                payload: response.data,
            })

            return response
        } catch (e) {
            const error = e as AxiosError<ErrorResponse>

            return new Promise((_, reject) => {
                reject(error)
            })
        }
    }
}

export const setServiceList = (serviceList: Service[]): ServiceActionTypes => {
    return {
        type: SET_SERVICE_LIST,
        payload: serviceList,
    }
}
